
import { ResponseCustom } from 'src/app/models/ResponseCustom';
import { Component, OnInit } from '@angular/core';
import { FileImportService } from './file-import.service';
import { AuthServiceCustom } from 'src/app/core/auth/authServiceCustom';
import { NgxSpinnerService } from 'ngx-spinner';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { SessionBusiness } from 'src/app/core/_config/sessionBusiness.service';

@Component({
  selector: 'kt-file-import',
  templateUrl: './file-import.component.html',
  styleUrls: ['./file-import.component.scss']
})
export class FileImportComponent implements OnInit {

  constructor(
    private fileImportService: FileImportService,
    private authServiceCustom: AuthServiceCustom,
    private spinner: NgxSpinnerService,
    private router: Router,
    private sessionBusiness: SessionBusiness
  ) { }

  ngOnInit(): void {
  }

  selectedFile: File = null;

  responsePostFile: ResponseCustom;

  onSelectFile(fileInputEvent: any) {

    this.selectedFile = <File>fileInputEvent.target.files[0];
    this.upload(fileInputEvent);
  }


  upload(data) {

    const formData = new FormData();
    formData.append('File', this.selectedFile);

    this.spinner.show();
    this.fileImportService.postFile(formData).subscribe(responsePostFile => {

      this.spinner.hide();

      let queryParams = _.pick(responsePostFile.data, ['id', 'processStatusString']);

      this.router.navigate([`fileReturn/file-audit/`, queryParams]);

      this.selectedFile = null;
    });
  }
}
